module.exports = __webpack_public_path__ + "static/media/desc-arrow.121e884e.svg";